export default __webpack_public_path__ + "static/media/sign-up-background.311cb611.png";